const matches = [
  // pattern,                              user?,  seller?
  [/^\/?$/,                                 true,   false],
  [/^\/stats\/?$/,                          true,    true],
  [/^\/items\/\d+\/customisations\/?$/,     true,    true],
  [/^\/reviews\/\d+\/new\/?$/,              true,   false],
  [/^\/reviews\/O_[-a-zA-Z0-9]+\/new\/?$/, false,   false],
];

export default (path, user) => (
  matches.some(match => {
    if ((match[1] || match[2]) && user === null) return false;
    if (match[2] && !user.isSeller) return false;
    return match[0].exec(path);
  })
)



// WEBPACK FOOTER //
// ./src/utils/route-authenticator.js